import mod from '@/js/modernisierung';
import konstanten from '@/js/konstanten';
import {kasseClient} from '@/js/helpers/backend-clients';
import {defaultState} from './state';
import UploadFile from '@/js/uploadFile';
import {displayAxiosError} from '@/js/helpers/utils';

export default {

  SET_OBJEKTART(state, objektart) {
    state.allgemeineAngaben.objektart = objektart;
  },
  SET_ERMITTLUNGSSTICHTAG(state, ermittlungsstichtag) {
    state.allgemeineAngaben.ermittlungsstichtag = ermittlungsstichtag;
  },
  SET_BAUJAHR(state, baujahr) {
    state.allgemeineAngaben.baujahr = baujahr;
  },
  SET_WOHNUNGSNUMMER(state, wohnungsnummer) {
    state.allgemeineAngaben.wohnungsnummer = wohnungsnummer;
  },
  SET_ANZAHL_WOHNEINHEITEN(state, anzahlWohneinheiten) {
    const number = parseInt(anzahlWohneinheiten);
    state.allgemeineAngaben.anzahlWohneinheiten = isNaN(number) ? undefined : number;
  },
  SET_ANZAHL_NUTZEINHEITEN(state, anzahlNutzeinheiten) {
    const number = parseInt(anzahlNutzeinheiten);
    state.allgemeineAngaben.anzahlNutzeinheiten = isNaN(number) ? undefined : number;
  },
  SET_WOHNFLAECHE(state, wohnflaeche) {
    const number = parseFloat(wohnflaeche);
    state.allgemeineAngaben.wohnflaeche = isNaN(number) ? undefined : number;
  },
  SET_NUTZFLAECHE(state, nutzflaeche) {
    const number = parseFloat(nutzflaeche);
    state.allgemeineAngaben.nutzflaeche = isNaN(number) ? undefined : number;
  },
  // Auftragsdaten
  SET_KAUFPREIS(state, kaufpreis) {
    state.auftragsdaten.kaufpreis = kaufpreis;
  },
  SET_GRUNDSTUECKSFLAECHE(state, grundstuecksflaeche) {
    state.auftragsdaten.grundstuecksflaeche = grundstuecksflaeche;
  },
  SET_GRUNDERWERBSSTEUERN(state, grunderwerbssteuern) {
    state.auftragsdaten.grunderwerbssteuern = grunderwerbssteuern;
  },
  SET_NOTARKOSTEN(state, notarkostenKaufvertrag) {
    state.auftragsdaten.notarkostenKaufvertrag = notarkostenKaufvertrag;
  },
  SET_GRUNDBUCHKOSTEN(state, kostenGrundbucheintragung) {
    state.auftragsdaten.kostenGrundbucheintragung = kostenGrundbucheintragung;
  },
  SET_BODENRICHTWERT(state, bodenrichtwertKaufzeitpunkt) {
    state.auftragsdaten.bodenrichtwertKaufzeitpunkt = bodenrichtwertKaufzeitpunkt;
  },
  SET_VERMIETET(state, vermietetKaufzeitpunkt) {
    state.auftragsdaten.vermietetKaufzeitpunkt = vermietetKaufzeitpunkt;
    if (!vermietetKaufzeitpunkt) {
      state.auftragsdaten.kaltmieteKaufzeitpunkt = undefined;
    }
  },
  SET_KALTMIETE(state, kaltmieteKaufzeitpunkt) {
    state.auftragsdaten.kaltmieteKaufzeitpunkt = kaltmieteKaufzeitpunkt;
  },

  // Lasten
  SET_BAULASTEN(state, baulasten) {
    state.lasten.baulasten = baulasten;
  },
  SET_BAULASTEN_ERLAEUTERUNG(state, erlaeuterungBaulasten) {
    state.lasten.erlaeuterungBaulasten = erlaeuterungBaulasten;
  },
  SET_ALTLASTEN(state, altlasten) {
    state.lasten.altlasten = altlasten;
  },
  SET_ALTLASTEN_ERLAEUTERUNG(state, erlaeuterungAltlasten) {
    state.lasten.erlaeuterungAltlasten = erlaeuterungAltlasten;
  },

  // Modernisierungen
  SET_KERNSANIERUNG(state, kernsanierung) {
    state.modernisierungen.kernsanierung = kernsanierung;
    if (!kernsanierung) {
      state.modernisierungen.jahrDerKernsanierung = undefined;
    }
  },
  SET_JAHR_DER_KERNSANIERUNG(state, jahrDerKernsanierung) {
    state.modernisierungen.jahrDerKernsanierung = jahrDerKernsanierung;
  },
  SET_BODENBELAEGE_MODERNISIERUNG(state, modernisierung) {
    state.modernisierungen.bodenbelaege.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE) {
      state.modernisierungen.bodenbelaege.jahrDerModernisierung = undefined;
    }
  },
  SET_BODENBELAEGE_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.modernisierungen.bodenbelaege.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_BAEDER_MODERNISIERUNG(state, modernisierung) {
    state.modernisierungen.baeder.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.modernisierungen.baeder.jahrDerModernisierung = undefined;
    }
  },
  SET_BAEDER_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.modernisierungen.baeder.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_HEIZUNG_MODERNISIERUNG(state, modernisierung) {
    state.modernisierungen.heizung.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.modernisierungen.heizung.jahrDerModernisierung = undefined;
    }
  },
  SET_HEIZUNG_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.modernisierungen.heizung.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_LEITUNGEN_MODERNISIERUNG(state, modernisierung) {
    state.modernisierungen.leitungen.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.modernisierungen.leitungen.jahrDerModernisierung = undefined;
    }
  },
  SET_LEITUNGEN_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.modernisierungen.leitungen.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_FENSTER_MODERNISIERUNG(state, modernisierung) {
    state.modernisierungen.fenster.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.modernisierungen.fenster.jahrDerModernisierung = undefined;
    }
  },
  SET_FENSTER_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.modernisierungen.fenster.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_DAEMMUNG_MODERNISIERUNG(state, modernisierung) {
    state.modernisierungen.daemmung.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.modernisierungen.daemmung.jahrDerModernisierung = undefined;
    }
  },
  SET_DAEMMUNG_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.modernisierungen.daemmung.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_DACH_MODERNISIERUNG(state, modernisierung) {
    state.modernisierungen.dach.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.modernisierungen.dach.jahrDerModernisierung = undefined;
    }
  },
  SET_DACH_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.modernisierungen.dach.jahrDerModernisierung = jahrDerModernisierung;
  },
  SET_RAUMAUFTEILUNG_MODERNISIERUNG(state, modernisierung) {
    state.modernisierungen.raumaufteilung.modernisierung = modernisierung;
    if (modernisierung === mod.KEINE.value) {
      state.modernisierungen.raumaufteilung.jahrDerModernisierung = undefined;
    }
  },
  SET_RAUMAUFTEILUNG_JAHR_DER_MODERNISIERUNG(state, jahrDerModernisierung) {
    state.modernisierungen.raumaufteilung.jahrDerModernisierung = jahrDerModernisierung;
  },

  //Auftragsunterlagen
  SET_AUFTRAGSUNTERLAGEN_GRUNDBUCHAUSZUG(state, grundbuchauszug) {
    state.auftragsunterlagen.grundbuchauszug = UploadFile.instanceOf(grundbuchauszug);
    kasseClient
      .uploadOrDelete(grundbuchauszug, 'kpa', '_unterlagen_grundbuchauszug', 0)
      .then(() => state.auftragsunterlagen.grundbuchauszug?.done())
      .catch(error => {
        displayAxiosError(error);
        state.auftragsunterlagen.grundbuchauszug = undefined;
      });
  },
  SET_AUFTRAGSUNTERLAGEN_KAUFVERTRAG(state, kaufvertrag) {
    state.auftragsunterlagen.kaufvertrag = UploadFile.instanceOf(kaufvertrag);
    kasseClient
      .uploadOrDelete(kaufvertrag, 'kpa', '_unterlagen_kaufvertrag', 0)
      .then(() => state.auftragsunterlagen.kaufvertrag?.done())
      .catch(error => {
        displayAxiosError(error);
        state.auftragsunterlagen.kaufvertrag = undefined;
      });
  },
  SET_AUFTRAGSUNTERLAGEN_GRUNDRISS(state, grundriss) {
    state.auftragsunterlagen.grundriss = UploadFile.instanceOf(grundriss);
    kasseClient
      .uploadOrDelete(grundriss, 'kpa', '_unterlagen_grundriss', 0)
      .then(() => state.auftragsunterlagen.grundriss?.done())
      .catch(error => {
        displayAxiosError(error);
        state.auftragsunterlagen.grundriss = undefined;
      });
  },
  SET_AUFTRAGSUNTERLAGEN_MIETVERTRAEGE(state, mietvertraege) {
    state.auftragsunterlagen.mietvertraege = UploadFile.instanceOf(mietvertraege);
    kasseClient
      .uploadOrDelete(mietvertraege, 'kpa', '_unterlagen_mietvertraege', 0)
      .then(() => state.auftragsunterlagen.mietvertraege?.done())
      .catch(error => {
        displayAxiosError(error);
        state.auftragsunterlagen.mietvertraege = undefined;
      });
  },
  SET_AUFTRAGSUNTERLAGEN_ENERGIEAUSWEIS(state, energieausweis) {
    state.auftragsunterlagen.energieausweis = UploadFile.instanceOf(energieausweis);
    kasseClient
      .uploadOrDelete(energieausweis, 'kpa', '_unterlagen_energieausweis', 0)
      .then(() => state.auftragsunterlagen.energieausweis?.done())
      .catch(error => {
        displayAxiosError(error);
        state.auftragsunterlagen.energieausweis = undefined;
      });
  },
  SET_AUFTRAGSUNTERLAGEN_BAUUNTERLAGEN(state, bauunterlagen) {
    state.auftragsunterlagen.bauunterlagen = UploadFile.instanceOf(bauunterlagen);
    kasseClient
      .uploadOrDelete(bauunterlagen, 'kpa', '_unterlagen_bauunterlagen', 0)
      .then(() => state.auftragsunterlagen.bauunterlagen?.done())
      .catch(error => {
        displayAxiosError(error);
        state.auftragsunterlagen.bauunterlagen = undefined;
      });
  },
  SET_AUFTRAGSUNTERLAGEN_TEILUNGSERKLAERUNG(state, teilungserklaerung) {
    state.auftragsunterlagen.teilungserklaerung = UploadFile.instanceOf(teilungserklaerung);
    kasseClient
      .uploadOrDelete(teilungserklaerung, 'kpa', '_unterlagen_teilungserklaerung', 0)
      .then(() => state.auftragsunterlagen.teilungserklaerung?.done())
      .catch(error => {
        displayAxiosError(error);
        state.auftragsunterlagen.teilungserklaerung = undefined;
      });
  },
  PUSH_AUFTRAGSUNTERLAGEN_ZUSATZDOKUMENT(state, zusatzdokument) {
    if (state.auftragsunterlagen.zusatzdokument.length < konstanten.MAX_NUMBER_ZUSATZDOKUMENTE) {
      state.auftragsunterlagen.zusatzdokument.push(UploadFile.instanceOf(zusatzdokument));
      kasseClient
        .uploadFile(zusatzdokument, 'kpa', '_unterlagen_zusatz')
        .then(() =>
          state.auftragsunterlagen.zusatzdokument.filter(dokument => dokument.file === zusatzdokument)[0]?.done(),
        )
        .catch(error => {
          displayAxiosError(error);
          const index = state.auftragsunterlagen.zusatzdokument
            .map(dokument => dokument.file)
            .indexOf(zusatzdokument);
          state.auftragsunterlagen.zusatzdokument.splice(index, 1);
        });
    }
  },
  REMOVE_AUFTRAGSUNTERLAGEN_ZUSATZDOKUMENT(state, zusatzdokument) {
    const index = state.auftragsunterlagen.zusatzdokument.map(dokument => dokument.file).indexOf(zusatzdokument);
    if (index > -1) {
      kasseClient
        .deleteFile('kpa', '_unterlagen_zusatz', index)
        .then(() => state.auftragsunterlagen.zusatzdokument.splice(index, 1));
    }
  },

  //Ansprechpartner
  SET_ANSPRECHPARTNER_NAME_2(state, nachname) {
    window.sessionStorage.setItem('nname', nachname);
    state.allgemeineAngaben.auftraggeberName2 = nachname;
    state.ansprechpartner.nachname = nachname;
  },
  SET_ANSPRECHPARTNER_NAME_1(state, vorname) {
    window.sessionStorage.setItem('vname', vorname);
    state.allgemeineAngaben.auftraggeberName1 = vorname;
    state.ansprechpartner.vorname = vorname;
  },
  SET_ANSPRECHPARTNER_TELEFON(state, telefon) {
    state.ansprechpartner.telefon = telefon;
  },
  SET_ANSPRECHPARTNER_ERLAEUTERUNG(state, erlaeuterung) {
    state.ansprechpartner.erlaeuterung = erlaeuterung;
  },
  SET_ALTERNATE_ANSPRECHPARTNER_NAME(state, alternateName) {
    state.ansprechpartner.altName = alternateName;
  },
  SET_ALTERNATE_ANSPRECHPARTNER_FUNCTION(state, alternateFunction) {
    state.ansprechpartner.altFunktion = alternateFunction;
  },
  SET_ALTERNATE_ANSPRECHPARTNER_TELEFON(state, alternateTelefon) {
    state.ansprechpartner.altTelefon = alternateTelefon;
  },
  SET_ALTERNATE_ANSPRECHPARTNER_EMAIL(state, alternateEmail) {
    state.ansprechpartner.altEmail = alternateEmail;
  },

  // Rechnungsadresse
  SET_DEFAULT_RECHNUNG_NAME1(state, name1) {
    state.defaultRechnung.name1 = name1;
  },
  SET_DEFAULT_RECHNUNG_NAME2(state, name2) {
    state.defaultRechnung.name2 = name2;
  },
  SET_DEFAULT_RECHNUNG_PLZ(state, plz) {
    state.defaultRechnung.plz = plz;
  },
  SET_DEFAULT_RECHNUNG_ORT(state, ort) {
    state.defaultRechnung.ort = ort;
  },
  SET_DEFAULT_RECHNUNG_STR(state, str) {
    state.defaultRechnung.str = str;
  },
  SET_DEFAULT_RECHNUNG_HNR(state, hnr) {
    state.defaultRechnung.hnr = hnr;
  },

  SET_ALTERNATIVE_RECHNUNG_NAME1(state, name1) {
    state.alternativeRechnung.name1 = name1;
  },
  SET_ALTERNATIVE_RECHNUNG_NAME2(state, name2) {
    state.alternativeRechnung.name2 = name2;
  },
  SET_ALTERNATIVE_RECHNUNG_PLZ(state, plz) {
    state.alternativeRechnung.plz = plz;
  },
  SET_ALTERNATIVE_RECHNUNG_ORT(state, ort) {
    state.alternativeRechnung.ort = ort;
  },
  SET_ALTERNATIVE_RECHNUNG_STR(state, str) {
    state.alternativeRechnung.str = str;
  },
  SET_ALTERNATIVE_RECHNUNG_HNR(state, hnr) {
    state.alternativeRechnung.hnr = hnr;
  },
  SET_USE_DEFAULT_RECHNUNG_DATA(state, useDefault) {
    state.alternativeRechnung.useDefault = useDefault;
  },

  RESET_STATE(state) {
    window.sessionStorage.removeItem('vname');
    window.sessionStorage.removeItem('nname');
    Object.assign(state, defaultState());
  },
};
